import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';

export default function TermAndCondition({ formData, setFormData, formErrors }) {
  const handleChange = e => {
    const { name, type, checked, value } = e.target;
    setFormData({ ...formData, [name]: type === 'checkbox' ? checked : value });
  };

  return (
    <div className="terms-and-conditions-form">
      <h2 className="mb-4">Terms & Conditions</h2>

      <Form.Group className="mb-3">
        <Form.Check
          type="checkbox"
          id="acknowledgePrivatePay"
          label={
            <>
              I understand that not all treatments are covered by OHIP
              <span style={{ color: 'red' }}>&nbsp;*</span>
            </>
          }
          name="i_understand_that_not_all_treatments_are_covered_by_ohip"
          checked={formData.i_understand_that_not_all_treatments_are_covered_by_ohip}
          onChange={handleChange}
          required
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Check
          type="checkbox"
          id="acknowledgePrivacyPolicy"
          label={
            <>
              I have read and acknowledge the Hannam Fertility&nbsp;
              <a href="https://www.hannamfertility.com/privacy-policy" target="_blank" rel="noopener noreferrer">
                Privacy Policy
              </a>
              &nbsp;and I consent to being contacted by HFC via email, text message, and web-based tools.&nbsp;<span style={{ color: 'red' }}>*</span>
            </>
          }
          name="i_have_read_and_acknowledge_the_hfc_privacy_policy__and_i_consent_to_hannam_fertility_centre_using_email_text_and_web_tools_to_contact_me"
          checked={formData.i_have_read_and_acknowledge_the_hfc_privacy_policy__and_i_consent_to_hannam_fertility_centre_using_email_text_and_web_tools_to_contact_me}
          onChange={handleChange}
          required
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Check type="checkbox" id="acknowledgeMarketingPolicy" label="I agree to receive communications for marketing and promotional purposes, from which I can unsubscribe at any time." name="marketing_policy" checked={formData.marketing_policy} onChange={handleChange} />
      </Form.Group>
    </div>
  );
}
